// --------------------------------------------------------------------------
// #TBC - Bird Images Modal
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var Modal = require('../modal');
var modalDisplay = new Modal();

module.exports = function (options) {
	var context = options.context;

	function init() {
		context.each(function (i) {
			var thisContext = $(this);
			var $modalContent = thisContext.find('[data-binding="modal"]');
			modalDisplay.externalModal(thisContext, $modalContent, 'birdbox' + i);
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-modal.js
// module id = 232
// module chunks = 0